export const GET_BY_LEDGER_CODE = "/umbrella/ledgers"

/** REGISTRO DE PROVIDER */
export const CREATE_ONG = "/umbrella/ong/register"
export const CREATE_PROVIDER = "/umbrella/providers/register"
export const GET_POSTAL_CODE = "/umbrella/geo/postal-code"
export const GET_TYPE_DOCUMENTS_PROVIDER = "/umbrella/documents"
export const GET_TYPE_DOCUMENTS_ONG = "/umbrella/documents"

/**REGISTRO DE PASSAGEIRO */
export const CREATE_PASSAGER = "/umbrella/customers/register"


/*BUSCAR POLITICAS*/
export const GET_POLICIES = "/umbrella/app/policies";
export const GET_POLICIE = "/umbrella/app/term";